import React from 'react'
import './Offers.css'
import exclusive_image from '../Assets/exclusive_image.png'
import {Link} from 'react-router'

const Offers = () => {


  return (
    <div className='offers'>
        <div className='offers-left'>
            <h1>Egyedülálló</h1>
            <h2>Ajánlatok csak neked</h2>
            <p>CSAK ITT NÁLUNK</p>
            <Link to={'/womens'}><button >Lecsekkolom</button></Link>
        </div>
        <div className="offers-right">
            <img src={exclusive_image} alt="" />
        </div>
    </div>
  )
}

export default Offers